module.exports = __webpack_public_path__ + "static/media/mainSlide3.8f016480.jpg";